import { render, staticRenderFns } from "./sensitiveWordList.vue?vue&type=template&id=6107a135"
import script from "./sensitiveWordList.vue?vue&type=script&lang=js"
export * from "./sensitiveWordList.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWordList.vue?vue&type=style&index=0&id=6107a135&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports